import { render, staticRenderFns } from "./InternalPromoListComponent.vue?vue&type=template&id=69dae13e"
import script from "./InternalPromoListComponent.vue?vue&type=script&lang=js"
export * from "./InternalPromoListComponent.vue?vue&type=script&lang=js"
import style0 from "./InternalPromoListComponent.vue?vue&type=style&index=0&id=69dae13e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports